export default "__VITE_ASSET__DkoBBDao__"